import React from "react";
import './c32_text_in_column.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import {insertHtml} from "../../utils/dom";
import {chunk} from "../../utils/utils";

class C32TextInColumn extends TemplateComponent {

    componentRender(data) {
        let feesArray = data.fees_section;

        let array = chunk(feesArray, 2);

        // Creating 2 different arrays
        const firstArray = array[0];
        const secondArray = array[1];

        return (
            <div className="c32-text-in-column">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            {data.title ? <div className={!isMobileOnly ? 'tasse-universitarie-title' : 'tasse-universitarie-title-mob'}>{data.title}</div> : null}
                            {data.subtitle ? <div className={!isMobileOnly ? 'tasse-universitarie-subtitle' : 'tasse-universitarie-subtitle-mob'} {...insertHtml(data.subtitle)} /> : null}
                            <div className="container-fluid tasse-universitarie-container">
                                <div className="row">
                                    <div className="col">
                                        <ul className={!isMobileOnly ? 'tasse-universitarie-list' : 'tasse-universitarie-list-mob'}>
                                            <div className="container-fluid">
                                                <div className="row">
                                                    {firstArray && firstArray.map((feeField, index) => (
                                                        <div key={index}>
                                                            <li className="col">
                                                                <hr className="horizontal-line"/>
                                                                {feeField.title ? <div className={!isMobileOnly ? 'tasse-universitarie-list-title' : 'tasse-universitarie-list-title-mob'}>{feeField.title}</div> : null}
                                                                <div className={!isMobileOnly ? 'tasse-universitarie-list-description' : 'tasse-universitarie-list-description-mob'} {...insertHtml(feeField.description)} />
                                                            </li>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </ul>
                                        <ul className={!isMobileOnly ? 'tasse-universitarie-list' : 'tasse-universitarie-list-mob'}>
                                            <div className="container-fluid">
                                                <div className="row">
                                                    {secondArray && secondArray.map((feeField, index) => (
                                                        <div key={index}>
                                                            <li className="col">
                                                                <hr className="horizontal-line"/>
                                                                {feeField.title ? <div className={!isMobileOnly ? 'tasse-universitarie-list-title' : 'tasse-universitarie-list-title-mob'}>{feeField.title}</div> : null}
                                                                <div className={!isMobileOnly ? 'tasse-universitarie-list-description' : 'tasse-universitarie-list-description-mob'}{...insertHtml(feeField.description)} />
                                                            </li>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default C32TextInColumn;
